/* eslint-disable no-unused-vars, no-useless-constructor*/
import React from 'react';
import PropTypes from 'prop-types';
import BaseComponent from '../../../panther/components/base/BaseComponent';

import ContactCardChannel from './ContactCardChannel/ContactCardChannel';

import styles from './ContactCard.css';

class ContactCard extends BaseComponent {
    constructor() {
        super();
    }

    render() {
        let content = this.renderChannels();

        return (
            <div className="contact-card">
                <div className="contact-card-header">
                    <span>{this.props.position}</span>
                    <h3>{this.props.name}</h3>
                </div>
                <hr className="contact-card-divider"/>
                <div className="contact-card-body">
                    {content}
                </div>
            </div>
        );
    }

    renderChannels(){
        let channels = this.props.channels;
        let content = [];

        channels.map((channel, index) => {
           content.push(<ContactCardChannel
               key={channel.type + "-" + index}
               type={channel.type}
               address={channel.address}
               addressDisplay={channel.addressDisplay}
           />);
           return content;
        });

        return content;
    }
}

ContactCard.propTypes = {
    position: PropTypes.string,
    name: PropTypes.string,
    channels: PropTypes.array,
};

export default ContactCard;